import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'palettes/unpairedPalette',
    pluginName: 'PALETTE',
    entityName: 'UNPAIRED_PALETTE',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch unpairedPalette action creators
export const fetchUnpairedPaletteInit = () => {
    return crudActions.fetchInit();
};
export const fetchUnpairedPaletteStart = () => {
    return crudActions.fetchStart();
};
export const fetchUnpairedPaletteSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchUnpairedPaletteFail = () => {
    return crudActions.fetchFail();
};

export const fetchUnpairedPaletteCount = (filter, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchUnpairedPaletteStart());
        try {
            let countRes = await rest.post("palettes/unpairedPalette/count", filter, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchUnpairedPaletteSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchUnpairedPaletteFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch unpaired palette."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchUnpairedPaletteFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch unpaired palette."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};

export const fetchUnpairedPalette = (filter, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchUnpairedPaletteStart());
        try {

            let listRes = await rest.post("palettes/unpairedPalette/list", filter, { cancelToken: options.countSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchUnpairedPaletteSuccess(filter.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchUnpairedPaletteFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchUnpairedPaletteFail());

            return { data: [] };
        }
    }
};
export const createFromExternal = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/unpairedPalette/createFromExternal', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create palette."}`,
                    options: {
                        variant: 'success'
                    }
                });

                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const assignExternalID = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/palettes/unpairedPalette/assignExternalID', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot assign to existing palette."}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            }
            else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
